import gql from 'graphql-tag';

import type { Workspace } from 'src/data/workspace';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp, type GraphQLEdgesResult, unwrapEdges } from 'src/lib/graphql';

import { WORKSPACE_FRAGMENT } from './schema';

const QUERY = gql`
  query Workspaces($customerId: ID!) {
    workspaces(customerId: $customerId) {
      edges {
        node {
          ...Workspace
        }
      }
    }
  }
  ${WORKSPACE_FRAGMENT}
`;

interface Options {
  abortSignal?: AbortSignal;
}

export const queryWorkspaces = async (customerId: ID, options?: Options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<GraphQLEdgesResult<Workspace>>(result.data);
  return unwrapEdges(data?.edges);
};
